<template>
  <div id="app">
    <!-- 어드민 페이지가 아닐 때만 UI 표시 -->
    <template v-if="!isAdminPage">
      <SplashScreen v-if="showSplash" @close="onSplashClose" />
      <PopupBanner />
      <FloatingBottomBar />
      <MainHeader />
    </template>

    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import MainHeader from '@/components/web/common/MainHeader.vue'
import SplashScreen from '@/components/web/common/SplashScreen.vue'
import PopupBanner from '@/components/web/common/PopupBanner.vue'
import FloatingBottomBar from '@/components/web/common/FloatingBottomBar.vue'

export default {
  name: 'App',
  components: {
    MainHeader,
    SplashScreen,
    PopupBanner,
    FloatingBottomBar
  },
  data() {
    return {
      showSplash: true
    }
  },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    }
  },
  methods: {
    onSplashClose() {
      this.showSplash = false
      window.dispatchEvent(new Event('splash-done'))
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/fonts-archive/Paperlogy/subsets/Paperlogy-dynamic-subset.css');
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css');
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400;1,600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap');

:root {
  /* 폰트 */
  --font-paperlogy: 'Paperlogy', sans-serif;
  --font-pretendard: 'Pretendard Variable', 'Pretendard', sans-serif;
  --font-serif: 'Cormorant Garamond', serif;
  --font-luxury: 'Cinzel', serif;
  --font-script: 'Great Vibes', cursive;

  /* 컬러 - 레이원시티 네이비 */
  --rayone-primary: #1B2A4A;        /* Navy */
  --rayone-primary-light: #2C4470;  /* Navy Light */
  --rayone-primary-dark: #111C33;   /* Navy Dark */
  --summit-black: #101820;          /* Black */
  --summit-dark-gray: #4C4B48;      /* Dark Gray */
  --summit-gray: #707372;           /* Gray */
  --text-color: #101820;
  --white: #ffffff;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: var(--font-pretendard);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
}

.main-content {
  /* padding-top 제거 - 풀스크린 섹션용 */
}

</style>
